module.exports = __webpack_public_path__ + "assets/images/1$.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/1$.png
// module id = 1268
// module chunks = 1